// ロボリンクや、求人LP上のロボページ関連
import { mapState } from 'vuex'
import resetLocalStorageSeeker from '@/functions/resetLocalStorageSeeker'
const chatbotSingleMixin = {
  data() {
    return {
      viewType: 0,
      isDemo: false,
      weekday: ['日', '月', '火', '水', '木', '金', '土'],
      isMessage: false,
      isTyping: '',
      isTypingScroll: false,
      isMobileInput: false,
      height: 45,
      flex: 0.5,
      num: null,
      companyid: null,
      botid: null,
      userData: {
        url: null,
        appname: null,
        platform: null,
        width: null,
        height: null,
        color: null,
        referrer: null,
        useragent: null,
        ckey: null,
        cookies: null,
        sessionid: null,
        count: null,
      },
      chatbot: null,
      chatLen: false,
      fromSeekerEmailInfo: null, // Emailからアクセスされた応募者データ
      isErrFlg: false, // Errorの時に表示するモーダル
      isReFlg: false, // 再設定の時に表示するモーダル
    }
  },
  computed: {
    ...mapState('directtalk', [
      'chatLogs',
      'seeker',
      'data',
      'chatData',
      'widgetData',
      'typing',
      'mobileKey',
      'color',
      'power',
      'own',
      'messagePages',
      'isChatLogs',
      'ws',
      'messageLoading',
      'targetID',
      'target',
      'targetIcon',
      'chatTalkHistory',
      'roboArguments',
    ]),
    ...mapState('chatbot', [
      'scenarioTable',
      'isSwitch',
      'scenario',
      'isSCNLoading',
      'isAutomatic',
      'talkEnd',
      'minipk',
      'lastView',
      'roboPartsSetOutsideScenario',
      'roboPartsSetNextNode'
    ]),
    ...mapState('calendar', [
      'schedule',
      'recommendDate',
      'isRecommendScheduleLoading',
      'preserveSuggestedSchedulesList',
    ]),
  },
  created() {
    window.addEventListener('beforeunload', this.closeWindow)
  },
  beforeDestroy() {
    window.removeEventListener('beforeunload', this.closeWindow)
  },
  watch: {
    'seeker.id'() {
      var uri = process.env.WS_ENDPOINT + this.data.ckey + '/' + this.seeker.id + '/'
      localStorage.setItem('SID_' + this.$route.params.companyid, this.seeker.id)
      localStorage.setItem('CNT_' + this.$route.params.botid, this.seeker.count)
      this.$store.dispatch('directtalk/getMessage', { name: 'seeker', pages: this.messagePages })
      this.$store.dispatch('directtalk/connect', { uri: uri, category: 'widget' })
      this.$store.dispatch('directtalk/getRoom')
    },
    isSCNLoading() {
      if (this.isSCNLoading) {
        this.isTypingScroll = true
        this.$nextTick(() => {
          this.scrollDown()
        })
      } else {
        this.isTypingScroll = false
      }
    },
    chatLogs() {
      this.chatLen = false
      if (this.chatLogs.length !== 0) {
        this.$nextTick(() => {
          this.scrollDown()
        })
      }
    },
    chatbot() {
      // 各種アクションの履歴テーブル登録
      this.$store.dispatch('directtalk/createSeekerATHistory', {
        target: this.chatbot.display_name,
        action: 'click_room_link',
        url: this.data.url,
        element: 'button',
      })
      this.$store.dispatch('directtalk/setDT', {
        name: this.chatbot.display_name,
        icon: this.chatbot.icon_data,
        id: this.chatbot.bot_id,
        model: 'bot',
      })
      this.$store.dispatch('chatbot/setMiniPK', this.chatbot.pk || null)
      let id = this.chatbot.pk || this.chatbot.bot_id
      let lv = localStorage.getItem('scenariolv_' + id)
      if (lv) {
        lv = JSON.parse(lv)
        if (lv.node == '') {
          lv = null
          localStorage.removeItem('scenariolv_' + id)
        }
      }
      if (!lv && !sessionStorage.getItem('isSessionSwitching')) {
        resetLocalStorageSeeker(this.seeker.id)
        this.$store.dispatch('chatbot/getScenarioOne', {
          companyid: this.data.ckey,
          scenarioName: this.chatbot.scenario_name,
          node: 'INITIALIZE',
          rate: this.color.thinking_rate,
          minipk: this.minipk ? this.minipk : null,
        })
      }
      this.$store.commit('chatbot/SET_LAST_VIEW', lv)
    },
  },
  methods: {
    // 終了時処理
    closeWindow() {
      this.$store.dispatch('directtalk/createSeekerATHistory', {
        target: this.botid,
        action: 'robo_close',
        url: this.data.url,
        element: this.scenario.beforenode,
      })
    },
    reSetting() {
      this.isReFlg = false
    },
    closePage() {
      window.close()
    },
    reconnect() {
      if (this.ws == null) {
        // 再接続
        const uri = process.env.WS_ENDPOINT + this.data.ckey + '/' + this.seeker.id + '/'
        this.$store.dispatch('directtalk/connect', { uri: uri, category: 'widget' })
      }
    },
    scenarioStart(position) {
      if (position == 'top') {
        resetLocalStorageSeeker(this.seeker.id)
        this.$store.dispatch('chatbot/getScenarioOne', {
          companyid: this.data.ckey,
          scenarioName: this.chatbot.scenario_name,
          node: 'INITIALIZE',
          rate: this.color.thinking_rate,
          minipk: this.minipk ? this.minipk : null,
        })
        localStorage.removeItem('scenariolv_' + (this.minipk || this.targetID))
      } else if (position == 'continue') {
        const setItemName = 'CAL_' + this.targetID
        const setItemNamePre = 'PRECAL_' + this.targetID
        const scheduleData = localStorage.getItem(setItemName)
        if (scheduleData) {
          let parseData = JSON.parse(scheduleData)
          parseData.flg = true
          localStorage.setItem(setItemName, JSON.stringify(parseData))
          const preData = localStorage.getItem(setItemNamePre)
          if (preData) {
            this.$store.dispatch('calendar/setSuggestedSchedules', JSON.parse(preData))
          }
        }
        this.$store.dispatch('directtalk/restoreTalkHistory', (this.minipk || this.targetID))
        if (this.lastView.isPartsSet) {
          this.$store.dispatch('chatbot/setRoboPartsSetInside', {name: this.chatbot.scenario_name, node: this.lastView.partsSetOutsideNextNode})
        }
        this.$store.dispatch('chatbot/getScenarioOne', {
          companyid: this.data.ckey,
          scenarioName: this.lastView.isPartsSet ? 'parts-set' : this.chatbot.scenario_name,
          node: this.lastView.node,
          rate: this.color.thinking_rate,
          minipk: this.minipk ? this.minipk : null,
        })
      }
      this.$store.commit('chatbot/SET_LAST_VIEW', null)
    },
    nextScenario() {
      if (
        (!this.chatLen &&
          !this.messageLoading &&
          !this.isSCNLoading &&
          this.chatLogs[this.chatLogs.length - 1].status == 2) ||
        this.chatLogs[this.chatLogs.length - 1].status == 5 ||
        this.chatLogs[this.chatLogs.length - 1].status == 14 ||
        this.chatLogs[this.chatLogs.length - 1].status == 19
      ) {
        this.chatLen = true
        let scenarioName = null
        let nextNode = null
        if (this.scenario.output_flg === true) {
          scenarioName = this.roboPartsSetOutsideScenario
          nextNode = this.roboPartsSetNextNode
        } else {
          scenarioName = this.scenario.name
          nextNode = this.scenario.select[0].next_node
        }
        this.$store.dispatch('chatbot/getScenarioOne', {
          companyid: this.data.ckey,
          scenarioName: scenarioName,
          node: nextNode,
          rate: this.color.thinking_rate,
          minipk: this.minipk ? this.minipk : null,
        })
        localStorage.setItem(
          'scenariolv_' + (this.minipk || this.targetID),
          JSON.stringify({
            node: nextNode,
            date: Date().toString(),
            isPartsSet: scenarioName == 'parts-set',
            partsSetOutsideNextNode: scenarioName == 'parts-set' ? this.roboPartsSetNextNode : ''
          })
        )
      }
    },
    scrollDown() {
      var nodes = document.querySelectorAll('.chat-timeline')
      var last = nodes[nodes.length - 1]
      if (!last) return
      last.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'start' })
    },
    setLocalStorage(value) {
      localStorage.setItem('scenariolv_' + (this.minipk || this.targetID), value)
    },
  },
}
export default chatbotSingleMixin



// WEBPACK FOOTER //
// ./src/mixins/chatbotSingleMixin.js